export default __webpack_public_path__ + "static/media/309.b55b23a8.svg";